import React from 'react';
import styles from './button-to-common.module.scss';

interface ButtonToCommonProps {
	onClick:(event: React.MouseEvent<HTMLDivElement>) => void
}

export default function ButtonToCommon({onClick}:ButtonToCommonProps) {
	return (
		<div onClick={onClick} className={styles.default}>Посмотреть все услуги</div>
	)
}